module.exports = __webpack_public_path__ + "static/media/hair (26).a700d8f7.jpg";